import { render } from "./SearchField.vue?vue&type=template&id=b398a4ea&scoped=true"
import script from "./SearchField.vue?vue&type=script&lang=js"
export * from "./SearchField.vue?vue&type=script&lang=js"

import "./SearchField.vue?vue&type=style&index=0&id=b398a4ea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b398a4ea"

export default script